
import React from 'react';
import { Box, Text } from 'grommet';

const PropertyRow = ({title, value}) => {
    return (
        <Box direction="row" pad={{bottom: '12px'}}>
            <Box basis="1/4">
                <Text size="medium" color="dark-4">{title}:</Text>
            </Box>
            <Box basis="3/4">
                <Text size="medium">{value}</Text>
            </Box>
        </Box>
    );
}

export default PropertyRow;
